import { BasketContentCartItem } from './BasketContentCartItem';
import { BasketContentFooter } from './BasketContentFooter';
import { LastSavedItem } from './LastSavedItem';

export function BasketContentCart(props) {
    const { shoppingBag, actions, showContinueButton, toggleBascket, lastSavedItem } = props;
    const { items } = shoppingBag;
    
    return (
        <>
            <div className="show-box flex-column active-group active" id="bag-box" style={{ display: 'flex' }}>
                {items.map((item, index) => (<BasketContentCartItem item={item} key={`${item.fabric.id}-${index}`} actions={actions} />))}
                {items.length === 0 && <div className="body-text3 mt-32">You have no items in your shopping bag.</div>}
            </div>
            {items.length > 0 && <BasketContentFooter shoppingBag={shoppingBag} showContinueButton={showContinueButton} toggleBascket={toggleBascket} />}
            {items.length === 0 && lastSavedItem && <LastSavedItem item={lastSavedItem} actions={actions} />}
        </>
    );
}